import { render, staticRenderFns } from "./DiscountsPage.vue?vue&type=template&id=b1968408&scoped=true&"
import script from "./DiscountsPage.vue?vue&type=script&lang=js&"
export * from "./DiscountsPage.vue?vue&type=script&lang=js&"
import style0 from "./DiscountsPage.vue?vue&type=style&index=0&id=b1968408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1968408",
  null
  
)

export default component.exports